module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71836/img/blog-post-zero.png"